













import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CGoogleAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CGoogleAutocompleteInput.vue'
import { FullLocation } from '~/models/google'

export default defineComponent({
  components: { CGoogleAutocompleteInput, CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name } = toRefs(props)

    const { value, error, changeValues } = useDynamicForm(props)

    function handleChange(location: FullLocation) {
      const { address, geolocation } = location
      changeValues([
        {
          name: name.value,
          value: address
        },
        {
          name: 'geolocation',
          value: geolocation
        }
      ])
    }

    const inputIsValid = computed(() => !error.value)

    return { value, error, inputIsValid, handleChange }
  }
})
